import React, { useState } from 'react'
import Input from '../UI/Input'
import Button from '../UI/Button'

const ForgotPassword = () => {
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')
    const [error, setError] = useState(null)
    const [emailError, setEmailError] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError(null)
        setMessage('')
        setEmailError('')

        if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setEmailError('Please enter a valid email address.')
            return
        }

        setIsSubmitting(true)
        try {
            const response = await fetch(`${import.meta.env.VITE_BACKEND_URL}/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            })

            if (response.ok) {
                setMessage('If that email exists, a reset link has been sent.')
            } else {
                const data = await response.json()
                setError(data.error || 'Something went wrong.')
            }
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div className="mt-10 max-w-md mx-auto">
            <h2 className="text-2xl font-bold mb-4">Forgot Password</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <Input
                    type="email"
                    label="Email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={emailError}
                    required
                />
                <Button type="submit" size="lg" loading={isSubmitting} className="w-full">
                    Send Reset Link
                </Button>
            </form>
            {message && <p className="text-success mt-2">{message}</p>}
            {error && <p className="text-error mt-2">{error}</p>}
        </div>
    )
}

export default ForgotPassword
